// extracted by mini-css-extract-plugin
module.exports = {"goalForm":"GoalForm_goalForm__3eRAg","errorMsg":"GoalForm_errorMsg__2Y5CT"};